import { render, staticRenderFns } from "./FormularioInformeTecnico.vue?vue&type=template&id=ba141872&scoped=true"
import script from "./FormularioInformeTecnico.vue?vue&type=script&lang=js"
export * from "./FormularioInformeTecnico.vue?vue&type=script&lang=js"
import style0 from "./FormularioInformeTecnico.vue?vue&type=style&index=0&id=ba141872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba141872",
  null
  
)

export default component.exports